import { createFileRoute, Outlet } from "@tanstack/react-router";
import MenuSidebar from "@/components/settings/menu-sidebar";
import AdminGuard from "@/components/auth/admin-guard";

export const Route = createFileRoute("/_authenticated/settings/_layout")({
  component: SettingsLayout,
});

function SettingsLayout() {
  return (
    <AdminGuard>
      <div className="flex flex-col lg:flex-row min-h-screen overflow-x-hidden">
        <MenuSidebar />
        <div className="flex-1 lg:ml-46 w-full min-w-0 sm:px-0 lg:pl-4 h-full">
          <Outlet />
        </div>
      </div>
    </AdminGuard>
  );
}
